import jwtAxios from "@crema/services/auth/jwt-auth";
import {
  GET_BANNER,
  FETCH_START,
  FETCH_ERROR,
  FETCH_SUCCESS,
  GET_NEWS,
  GET_NEWS_ID,
  GET_GALLERY,
  GET_ANNOUNCEMENT,
  GET_BANNER_SATKER,
  GET_GALLERY_SATKER,
  GET_PESAN_SATKER,
  GET_BIRTHDAY_SATKER,
  GET_NEWS_SATKER,
  GET_NEWS_SATKER_ID,
  GET_NOTIFICATIONS,
  GET_COUNT_NOTIFICATIONS,
  READ_NOTIFICATION
} from "shared/constants/ActionTypes";
import { API } from 'shared/constants/AppEnums';
import { showMessage } from "./Common";

export const onGetBanner = () => {
  let url;
  url = API.PORTALBANNER;
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_BANNER,
            payload: { data: data.data }
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetNews = (page = 1) => {
  let url;
  url = API.PORTALNEWS + `?page=${page}`;
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_NEWS,
            payload: { data: data.data }
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetNewsSatker = (page = 1) => {
  let url;
  url = API.SATKERNEWS + `?page=${page}`;
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_NEWS_SATKER,
            payload: { data: data.data }
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetNewsId = (id, backtohome) => {
  let url;
  url = API.PORTALNEWSID.replace('$id', id);
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_NEWS_ID,
            payload: { data: data.data.results }
          });
        } else {
          backtohome()
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        backtohome()
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetNewsSatkerId = (id, backtohome) => {
  let url;
  url = API.SATKERNEWSID.replace('$id', id);
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_NEWS_SATKER_ID,
            payload: { data: data.data.results }
          });
        } else {
          backtohome()
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        backtohome()
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetGallery = (page = 1) => {
  let url;
  url = API.PORTALGALLERY + `?page=${page}`;
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_GALLERY,
            payload: { data: data.data }
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetAnnouncement = (page = 1, refresh = false) => {
  let url;
  url = API.GETANNOUNCEMENT + `?page=${page}`;
  return (dispatch) => {
    // dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          // dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_ANNOUNCEMENT,
            payload: { data: data.data, refresh: refresh }
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetNotifications = (page = 1, refresh = false) => {
  let url = API.GET_NOTIFICATIONS + `?page=${page}`;
  return (dispatch) => {
    // dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          // dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_NOTIFICATIONS,
            payload: { data: data.data, refresh: refresh }
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetCountNotifications = () => {
  let url = API.GET_COUNT_NOTIFICATIONS;
  return (dispatch) => {
    // dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          // dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_COUNT_NOTIFICATIONS,
            payload: { data: data.data }
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onPostAnnoucement = (data, handleClose) => {
  let url;
  url = API.POSTANNOUNCEMENT;
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post(url, data, API.requestOptionsPOST())
      .then((data) => {
        console.log("data ", data);
        if (data.status === 201) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch(showMessage('Submit Pengumuman Berhasil'));
          dispatch(onGetAnnouncement());
          handleClose();
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetBannerSatker = () => {
  let url;
  url = API.SATKERBANNER;
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_BANNER_SATKER,
            payload: { data: data.data }
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetGallerySatker = (page = 1) => {
  let url;
  url = API.SATKERGALLERY + `?page=${page}`;
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          console.log("ACTION GALLERY SATKER ", data, url);
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_GALLERY_SATKER,
            payload: { data: data.data }
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetPesanSatker = () => {
  let url;
  url = API.SATKERPESANDIRJER;
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_PESAN_SATKER,
            payload: { data: data.data }
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetBirthdaySatker = () => {
  let url;
  url = API.SATKERBIRTHDAY;
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_BIRTHDAY_SATKER,
            payload: { data: data.data }
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onReadNotification = (id) => {
  let url;
  url = API.READ_NOTIFICATIONS.replace('$id', id);
  return (dispatch) => {
    jwtAxios
      .put(url, {}, API.requestOptionsPUT())
      .then((data) => {
        dispatch({ type: READ_NOTIFICATION })
      })
      .catch((error) => {
        console.log(error.message)
      });
  };
};